import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {Layers, TheRaveLayers} from "../view/TheRaveLayers";
import {TheRave} from "../TheRave";
import {TimelineLite, TweenLite} from "gsap";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {TheRaveParsedData} from "../server/data/TheRaveParsedData";
import {TheRaveSound} from "../sound/TheRaveSound";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {FontStyleConfig} from "../config/FontConfig";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {Translation} from "../../core/utils/Translation";
import {TheRaveGameMode} from "../gameflow/TheRaveGameMode";

export class FreespinIntro extends ContinueScreen {

    private _introAnimation: PIXI.spine.Spine;
    private _textSpin: PIXI.Text;
    private _textSpins: PIXI.Text;
    private _isLandscape: boolean;
    private _isPlaying: boolean;
    private _number_FREESPIN: PIXI.BitmapText;

    constructor() {
        super(TheRaveLayers.getLayer(Layers.SCREENS)!);

        this._number_FREESPIN = new PIXI.BitmapText("", FontStyleConfig.FS_INTRO_NUMBER_FS);
        (<PIXI.Point>this._number_FREESPIN.anchor).set(1, 0.5);
        this._number_FREESPIN.position.set(-10, 20);

        this._textSpin = new PIXI.Text(Translation.translate("SPIN"), new PIXI.TextStyle({
            fill: 0xffffff,
            fontFamily: OpenSans.FAMILY,
            wordWrap: false,
            fontWeight: FontWeight.BOLD,
            fontSize: 30
        }));
        this._textSpin.anchor.set(0, 0.5);
        this._textSpin.position.set(360, 550);

        this._textSpins = new PIXI.Text(Translation.translate("SPINS"), new PIXI.TextStyle({
            fill: 0xffffff,
            fontFamily: OpenSans.FAMILY,
            wordWrap: false,
            fontWeight: FontWeight.BOLD,
            fontSize: 30
        }));
        this._textSpins.anchor.set(0, 0.5);
        this._textSpins.position.set(360, 550);
    }

    public show(onContinueCallBack: () => void): void {
        this.reset();
        SlotGame.keypadPlugin.hide();
        const gameData: TheRaveParsedData = TheRave.model.currentParsedData,
            isRestore: boolean = TheRave.model.isRestore,
            nextMode = gameData.nextMode,
            fsLeft = gameData.freespinsLeft,
            number = this._number_FREESPIN,
            spinsLeft = <PIXI.Sprite>(<any>this)[`_textSpin${fsLeft > 1 ? "s" : ""}`],
            animationName:string = `${gameData.nextMode === TheRaveGameMode.FREESPIN_SUPER?"S":""}FSINTRO`;
        if(this._introAnimation){
            this._container.removeChild(this._introAnimation);
        }
        this._introAnimation = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(animationName));
        this._introAnimation.visible = false;
        this._introAnimation.position.set(360, 303);
        this._introAnimation.scale.set(0.9, 0.9);
        this._container.addChild(this._introAnimation);

        number.text = `${fsLeft}`;
        spinsLeft.addChild(number);
        spinsLeft.alpha = 0;
        spinsLeft.visible = true;
        const fsTotalNum:number = gameData.freespinsLeft + gameData.numberOfFreespinsPlayed;
        const tl = new TimelineLite({paused: true});
        tl.add([
            () => {
                this._isPlaying = true;
                this.onOrientationChanged();
                this._container.addChild(spinsLeft);
                this.visible = true;
                if (!isRestore) {
                    TheRaveSound.bgFsIntroStart(true);
                }
                if (TheRave.reels && TheRave.reels.length > 0 && TheRave.reels[1]) {
                    TheRave.reels[1].hideBoostButton();
                }
            },
            TheRave.fullScreenDimLayer.start()], 0);

        tl.add(() => {
            if(gameData.nextMode === TheRaveGameMode.FREESPIN_SUPER && TheRave.apiPlugin.gameClientConfiguration.useCensoredGfxUS)
            {
                this._introAnimation.state.setAnimation(0, "intro_US_animation", true);
            }else{
                this._introAnimation.state.setAnimation(0, "animation", true);
            }
            this._introAnimation.visible = true;
        }, 0.8);
        tl.add(() => TheRaveSound.switchMusic(
            {name: `bgFs${fsTotalNum===8?2:(fsTotalNum===10?3:1)}Intro`, volume: 0},
            {name: `bgFs${fsTotalNum===8?2:(fsTotalNum===10?3:1)}Intro`, from: 0.5, to: 1, duration: 2000}
        ), 0.871);
        tl.add(TweenLite.to(spinsLeft, {duration: 0.2, alpha: 1}), 1);
        tl.add(() => {
            TheRave.background.updateEnvironment(gameData.nextMode);
            TheRave.stickySymbol.showMultiplier();
            super.show(onContinueCallBack);
        });
        tl.play(0);
    }

    protected close(): TimelineLite {
        const tl = new TimelineLite();
        const gameData: TheRaveParsedData = TheRave.model.currentParsedData;
        const fsTotalNum:number = gameData.freespinsLeft + gameData.numberOfFreespinsPlayed;
        TheRaveSound.switchMusic({name:`bgFs${fsTotalNum===8?2:(fsTotalNum===10?3:1)}`, volume: 1});
        tl.add(TweenLite.to(this, {duration: 1, alpha: 0}));
        TheRaveLayers.getRePositionLayers().forEach((layer:StageLayer|undefined)=>tl.add(TweenLite.to(layer!.position, {
            duration: 0.5,
            y: 40,
            ease: `power3.out`
        }),1));
        tl.add(() => {
            if(this._introAnimation){
                this._introAnimation.state.setEmptyAnimation(0,0);
                this._container.removeChild(this._introAnimation);
            }
            TheRave.fullScreenDimLayer.stop();
            TheRave.stickySymbol.setAllMultiplierInActive();
            SlotGame.keypadPlugin.show();
            this.visible = false;
            this.alpha = 1;
            this._continueButton.visible = false;
            this.reset();
        });
        const delay: number = tl.duration();
        if (TheRave.model.freespinTriggeredThisSpin) {
            let scatterNum: number = 0;
            gameData.scatterPositions.forEach((pos: number, i: number) => {
                if (pos > -1) {
                    scatterNum++;
                    TheRave.enhancerReels[i].reelView.isFreeSpin = true;
                    TheRave.enhancerReels[i].reelView.setPosition(pos + 1);
                    tl.add(TheRave.enhancerReels[i].reelView.showEnhancerPositionsBeforeFS(), delay);
                }
            });
            [1, 2, 3, 4, 0].forEach((s: number, i: number) => {
                tl.add(() => {
                    TheRave.enhancerReels[i].reelView.isFreeSpin = true;
                    TheRave.enhancerReels[i].reelView.setPosition(3);
                    TheRave.enhancerReels[s].reelView.updateGlow(i < scatterNum);
                });
            });
        } else if (TheRave.model.isRestore) {
            TheRave.model.currentParsedData.enhancerReel.forEach((hasEnhancer: boolean, i: number) => {
                if (hasEnhancer) {
                    tl.add(() => {
                        TheRave.enhancerReels[i].reelView.isFreeSpin = true;
                        TheRave.enhancerReels[i].reelView.setPosition(3);
                        TheRave.enhancerReels[i].reelView.updateGlow(true);
                    });

                }
            });
            gameData.scatterPositions.forEach((pos: number, i: number) => {
                if (pos > -1) {
                    TheRave.enhancerReels[i].reelView.isFreeSpin = true;
                    TheRave.enhancerReels[i].reelView.setPosition(pos + 1);
                    tl.add(TheRave.enhancerReels[i].reelView.showEnhancerPositionsBeforeFS(), delay);
                    tl.add( ()=>{
                        TheRave.enhancerReels[i].reelView.isFreeSpin = true;
                        TheRave.enhancerReels[i].reelView.setPosition(3);
                        TheRave.enhancerReels[i].reelView.updateGlow(true);
                    });
                }
            });
        }

        return tl;
    }

    public onOrientationChanged(): void {
        if (!this._isPlaying) {
            return;
        }
        super.onOrientationChanged();
        this._isLandscape = NolimitApplication.isLandscape;
    }

    private reset(): void {
        this._isPlaying = false;
        this._number_FREESPIN.text = "";
        this._textSpin.visible = false;
        this._textSpins.visible = false;
        this._textSpin.alpha = 0;
        this._textSpins.alpha = 0;
    }
}